import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Icon } from 'antd';
import ConversationStatus from '../../ConversationStatus';
import ConversationType from '../../ConversationType';
import './actionOptionsDropdown.less';
import { Translate } from '@above-the-treeline/localization';

ActionOptionsDropdown.propTypes = {
	status: PropTypes.string,
	type: PropTypes.object,
	unarchiveButton: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
	archiveButton: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
	markUnreadButton: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
	startConvoInOtherCommunitiesButton: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.element,
	]),
};

export default function ActionOptionsDropdown({
	status,
	type,
	unarchiveButton,
	archiveButton,
	markUnreadButton,
	startConvoInOtherCommunitiesButton,
}) {
	const [isLoading, setIsLoading] = React.useState(false);
	const menuItems = [
		{
			doShow: type === ConversationType.Title,
			menuItem: startConvoInOtherCommunitiesButton,
		},
		{
			doShow: status === ConversationStatus.read,
			menuItem: markUnreadButton,
		},
		{
			doShow: status === ConversationStatus.read,
			menuItem: archiveButton,
		},
		{
			doShow: status === ConversationStatus.archived,
			menuItem: unarchiveButton,
		},
	];
	const menu = (
		<Menu onClick={() => setIsLoading(true)}>
			{menuItems.map(
				(item, index) =>
					!isLoading &&
					item.doShow && (
						<Menu.Item key={index}>{item.menuItem}</Menu.Item>
					),
			)}
		</Menu>
	);

	return (
		<div className="action-options-dropdown">
			<Dropdown
				trigger={['click']}
				overlay={menu}
				onVisibleChange={() => setIsLoading(false)}>
				<span>
					<Translate id="options" /> <Icon type="down" />
				</span>
			</Dropdown>
		</div>
	);
}
